import axios from 'axios';
import { BehaviorSubject, fromEvent, from, Subject } from 'rxjs';
import { switchMap, map, filter, take, delay, takeUntil } from 'rxjs/operators';

let hasAlertsSubject = new BehaviorSubject<boolean>(false);
let hasAlerts$ = hasAlertsSubject.asObservable();
let buttonClick$ = fromEvent(
  document.querySelector('.riderAlertsButton'),
  'click'
);

let targetURL =
  window['targetURL'] ||
  'https://www8.miamidade.gov/transportation-publicworks/rider_alerts_current.asp';

const stopSubject = new Subject();
const stop$ = stopSubject.asObservable();

function getAlerts() {
  from(
    axios.get<Array<object>>(
      'https://api2.miamidade.gov/registration/api/routes'
    )
  )
    .pipe(
      filter((response: any) => {
        return response.data.data.riderAlerts !== null;
      }),
      map((response: any) => {
        return response.data.data.riderAlerts;
      }),
      switchMap((alerts: Array<object>) => {
        if (alerts.length > 0) {
          hasAlertsSubject.next(true);
        }
        return hasAlerts$;
      })
    )
    .subscribe(
      () => {},
      err => {
        console.log('error: ', err);
      },
      () => {
        // console.log('http request completed');
      }
    );
}

// Get the data from the completed http call onload.
window.onload = () => {
  // Call the function and subscribe to the http request.
  getAlerts();

  hasAlerts$.pipe(takeUntil(stop$)).subscribe(
    (hasAlerts: boolean) => {
      if (hasAlerts) {
        document
          .querySelector('.riderAlertsButton')
          .classList.add('showRiderAlertsButton');
      }
    },
    (error: Error) => {
      console.error('error: ', error);
    },
    () => {
      //   console.log('************************* completed');
    }
  );

  buttonClick$.subscribe(() => {
    stopSubject.next();
    window.location.href = targetURL;
  });
};

// Complete behavior subject onbeforeunload in order to avoid memory leaks.
window.onbeforeunload = () => {
  hasAlertsSubject.complete();
};
